import React from "react";

const STAT_ROWS = [
  { key: "sentence_mean", label: "Avg sentence", suffix: " words" },
  { key: "sentence_max", label: "Longest", suffix: " words" },
  { key: "sentence_min", label: "Shortest", suffix: " words" },
  { key: "contractions_per_100w", label: "Contractions", suffix: " /100w" },
  { key: "em_dash_per_100w", label: "Em-dashes", suffix: " /100w" },
  { key: "avg_word_length", label: "Word length", suffix: " letters" },
];

function Chips({ title, items, testId }) {
  if (!items?.length) return null;
  return (
    <div data-testid={testId}>
      <div className="label-eyebrow text-[10px] mb-1.5">{title}</div>
      <div className="flex flex-wrap gap-1.5">
        {items.map((t, i) => (
          <span key={i} className="text-[11px] px-2 py-1 rounded-full bg-[hsl(var(--secondary))] text-[hsl(var(--foreground))]">
            {t}
          </span>
        ))}
      </div>
    </div>
  );
}

/**
 * VoiceFingerprint — the measured profile of how one person writes.
 */
export default function VoiceFingerprint({ fingerprint, testId }) {
  if (!fingerprint) return null;
  const { stats = {}, description = {}, excerpts = [] } = fingerprint;

  return (
    <div data-testid={testId} className="mt-3 rounded-xl bg-[hsl(var(--secondary))]/50 p-4 space-y-4">
      {description?.register && (
        <div className="text-sm">
          <span className="text-[hsl(var(--muted-foreground))]">Register: </span>
          <span className="font-semibold">{description.register}</span>
        </div>
      )}

      <div className="grid grid-cols-2 sm:grid-cols-3 gap-x-6 gap-y-2">
        {STAT_ROWS.filter((r) => stats[r.key] !== undefined).map((r) => (
          <div key={r.key} className="flex items-baseline justify-between gap-2 min-w-0">
            <span className="text-xs text-[hsl(var(--muted-foreground))]">{r.label}</span>
            <span className="text-xs font-mono-editor tabular-nums shrink-0">
              {stats[r.key]}{r.suffix}
            </span>
          </div>
        ))}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Chips title="How they write" items={description?.habits} testId={`${testId}-habits`} />
        <Chips title="How they think on the page" items={description?.traits} testId={`${testId}-traits`} />
        <Chips title="Their own words" items={description?.signature_phrases} testId={`${testId}-phrases`} />
        <Chips title="Never does" items={description?.avoid} testId={`${testId}-avoid`} />
      </div>

      {stats.top_openers?.length > 0 && (
        <div className="text-xs text-[hsl(var(--muted-foreground))]">
          Usually opens sentences with: <span className="font-mono-editor">{stats.top_openers.join(", ")}</span>
        </div>
      )}

      {excerpts.length > 0 && (
        <blockquote className="text-xs italic text-[hsl(var(--muted-foreground))] border-l-2 border-[hsl(var(--border))] pl-3">
          “{excerpts[0]}”
        </blockquote>
      )}
    </div>
  );
}
